<script>
    import * as api from '../shared/api.js'

    export let company
    export let active
    export let onUpdate
    export let onRemove
    
    let loading = false
    let copy = Object.assign({}, company)
    let error = null

    $: obj   = (active === company.id ? copy : company)
    $: dirty = company.name !== copy.name || company.cnpj !== copy.cnpj

    function toggleActive() {
        if(active === company.id) {
            active = -1
        } else {
            active = company.id
        }
        copy = Object.assign({}, company)
    }

    function remove() {
        api
            .del(`/company/${company.id}`)
            .then(res => {
                if(res.status === 200) {
                    onRemove(company)
                }
            })
            .catch(console.log)
    }
    
    function store() {
        loading = true
        if(copy.id === 0) {
            api
                .post('/company', { name: copy.name, cnpj: copy.cnpj })
                .then(res => {
                    loading = false
                    if(res.status === 200) 
                        return res.json()
                    else
                        throw 'Erro ao salvar'
                })
                .then(json => {
                    onUpdate(json)
                    active = -1
                    company = { id: 0, name: '', cnpj: '' }
                })
                .catch(err => {
                    error = err
                    loading = false
                })

        } else {
            api
                .put('/company', { id: copy.id, name: copy.name, cnpj: copy.cnpj })
                .then(res => {
                    loading = false
                    if(res.status === 200) {
                        onUpdate(copy)
                        active = -1
                    } else {
                        throw 'Erro ao salvar'
                    }
                })
                .catch(err => {
                    error = err
                    loading = false
                })
        }
    }
</script>

<style>
    .head {
        font-size: 16pt;
    }

    .entry {
        margin: 0;
        transition: all 1s linear;
    }

    .entry.active:not(:first-child):not(:last-child) {
        margin: 6px 0 !important;
    }

    .entry.active:first-child {
        margin-bottom: 6px !important;
    }

    .entry.active:last-child {
        margin-top: 6px !important;
    }

    .entry .head {
        display: flex;
    }

    .entry .head {
        flex: 1;
    }

    .form {
        overflow: hidden;
        height: 180px;
        transition: all 1s ease;
        display: block;
    }
    
    .form.hidden {
        height: 0px;
    }

    .form .item {
        margin: 1em 0;
    }

    .ui.label {
        width: 80px;
    }
</style>

<div class="ui segment entry {obj.id === active ? 'active' : ''}">
    {#if loading}
        <div class="ui active dimmer">
            <div class="ui loader"></div>
        </div>
    {/if}
    <div class="head">
        <div style="flex: 1">
            <slot name="header"></slot>
        </div>
        {#if obj.id > 0}
            <button class="ui button" on:click={remove}>Remover</button>
        {/if}
        <button class="ui primary button" on:click={toggleActive}>
            {#if obj.id === 0}              Adicionar 
            {:else if obj.id === active}    Cancelar  
            {:else}                         Editar 
            {/if}
        </button>
    </div>
    <div class="form" class:hidden={obj.id !== active}>
        <div class="item">
            <div class="ui labeled big input" >
            <div class="ui label">Nome</div>
                <input  id="email" 
                        type="text"
                        bind:value={copy.name} 
                        autocomplete="false" >
            </div>
        </div>
        <div class="item">
            <div class="ui labeled big input" >
            <div class="ui label">CNPJ</div>
                <input  id="email" 
                        type="text" 
                        bind:value={copy.cnpj} 
                        autocomplete="false" >
            </div>
        </div>
        <div class="item">
            <button class="ui primary button" on:click={store} disabled={!dirty}>Salvar</button>
            {#if dirty && error}
                <div class="ui small red label">{error}</div>
            {/if}
        </div>
    </div>
</div>
